export default __webpack_public_path__ + "static/media/motor-home.597f8a54.png";